/** Month-grid arithmetic for the diary calendar, pure and tested. Weeks start on Monday. */
export interface Cell {
  date: string
  day: number
  inMonth: boolean
}

const iso = (d: Date) => d.toISOString().slice(0, 10)

export function monthGrid(month: string): Cell[] {
  const first = new Date(`${month}-01T00:00:00Z`)
  const lead = (first.getUTCDay() + 6) % 7
  const days = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)).getUTCDate()
  const total = Math.ceil((lead + days) / 7) * 7
  return Array.from({ length: total }, (_, i) => {
    const d = new Date(first.getTime() + (i - lead) * 86_400_000)
    return { date: iso(d), day: d.getUTCDate(), inMonth: iso(d).startsWith(month) }
  })
}

export function shiftMonth(month: string, by: number): string {
  const d = new Date(`${month}-01T00:00:00Z`)
  d.setUTCMonth(d.getUTCMonth() + by)
  return iso(d).slice(0, 7)
}
